import seedRestaurants from '../data/seed-restaurants.json';
import bundledReferenceManifest from '../data/reference-manifest.json';
import { fetchActiveRestaurants, firebaseConfigured } from './firebaseRest';

let runtimeManifest = bundledReferenceManifest;
let referenceById = buildReferenceMap(runtimeManifest);
let manifestSource = 'bundled';

function buildReferenceMap(manifest) {
  return new Map(manifest.map((item) => [item.restaurantId, item.images]));
}

function normalizeManifest(payload) {
  const raw = Array.isArray(payload) ? payload : payload?.restaurants;
  if (!Array.isArray(raw)) return null;
  return raw
    .filter((item) => item && typeof item.restaurantId === 'string' && Array.isArray(item.images))
    .map((item) => ({
      restaurantId: item.restaurantId,
      images: item.images.filter((image) => typeof image === 'string' && image.length > 0),
    }))
    .filter((item) => item.images.length > 0);
}

async function fetchManifest(url) {
  const response = await fetch(url, {
    cache: 'no-store',
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) throw new Error(`Reference index returned ${response.status}`);
  const payload = await response.json();
  const manifest = normalizeManifest(payload);
  if (!manifest) throw new Error('Reference index response is invalid');
  return manifest;
}

export async function refreshReferenceManifest() {
  const stamp = Date.now();
  const endpoints = [
    `/api/reference-images.php?t=${stamp}`,
    `/reference-images/manifest.json?t=${stamp}`,
  ];

  for (const endpoint of endpoints) {
    try {
      const manifest = await fetchManifest(endpoint);
      runtimeManifest = manifest;
      referenceById = buildReferenceMap(runtimeManifest);
      manifestSource = endpoint.includes('.php') ? 'server-folder' : 'static-manifest';
      return { manifest: runtimeManifest, source: manifestSource };
    } catch (error) {
      console.warn(`Reference index unavailable at ${endpoint}`, error);
    }
  }

  runtimeManifest = bundledReferenceManifest;
  referenceById = buildReferenceMap(runtimeManifest);
  manifestSource = 'bundled';
  return { manifest: runtimeManifest, source: manifestSource };
}

function enrich(items) {
  return items.map((restaurant) => {
    const referenceImages = referenceById.get(restaurant.id) || [];
    return {
      aliases: [],
      active: true,
      order: 0,
      ...restaurant,
      referenceImages,
      coverImage: restaurant.coverImage || referenceImages[0] || '',
    };
  });
}

export async function loadRestaurantDirectory() {
  const referenceResult = await refreshReferenceManifest();
  if (!firebaseConfigured) {
    return {
      restaurants: enrich(seedRestaurants),
      source: 'bundled',
      referenceSource: referenceResult.source,
    };
  }
  try {
    const restaurants = await fetchActiveRestaurants();
    if (!restaurants.length) {
      return {
        restaurants: enrich(seedRestaurants),
        source: 'bundled-empty',
        referenceSource: referenceResult.source,
      };
    }
    return {
      restaurants: enrich(restaurants),
      source: 'firebase',
      referenceSource: referenceResult.source,
    };
  } catch (error) {
    console.error('Firebase directory fallback:', error);
    return {
      restaurants: enrich(seedRestaurants),
      source: 'bundled-offline',
      referenceSource: referenceResult.source,
      error,
    };
  }
}

export function getReferenceManifest() {
  return runtimeManifest;
}

export function getReferenceManifestSource() {
  return manifestSource;
}

export function enrichRestaurants(items) {
  return enrich(items);
}

export { seedRestaurants };
